import React, { useEffect, useRef, useState } from "react";
import styles from "../../../styles/home/Components/Welcome.module.css";
import apostleImage from "../../../assets/images/father.png";
import legalRepImage from "../../../assets/images/RevEspoir.png";
import { FaQuoteLeft, FaCross } from "react-icons/fa";
import { MdVerified } from "react-icons/md";

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) { setInView(true); observer.disconnect(); }
      },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return [ref, inView];
}

const LEADERS = [
  {
    image: apostleImage,
    name: "Apostle Sebagabo Christophe",
    title: "Senior Pastor & Founder",
    role: "Founder",
    quote:
      "Please allow me to personally welcome you to the Calvary Wide Fellowship Ministries website. We are delighted that you're here. This platform is designed to introduce you to the heart of our ministry and provide resources to support your spiritual growth and wholeness in Christ.",
  },
  {
    image: legalRepImage,
    name: "Rev. Pr. Espoir SERUGO",
    title: "Legal Representative",
    role: "Leadership",
    quote:
      "We invite you to explore and discover what God is doing through this ministry. While this site offers a glimpse, the true heart of CWFM is experienced in fellowship. We look forward to welcoming you and sharing this journey of faith together. Blessings.",
  },
];

function LeaderCard({ leader, delay, side }) {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={`${styles.leaderCard} ${inView ? styles.leaderCardVisible : ""} ${
        side === "left" ? styles.fromLeft : styles.fromRight
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {/* Full-bleed background image */}
      <img src={leader.image} alt={leader.name} className={styles.cardBg} />

      {/* Layered gradients */}
      <div className={styles.cardGradientTop} />
      <div className={styles.cardGradientBottom} />

      {/* Overlaid content */}
      <div className={styles.cardContent}>
        <span className={styles.roleTag}>
          <MdVerified className={styles.roleIcon} />
          {leader.role}
        </span>

        <div className={styles.cardBottom}>
          <h3 className={styles.leaderName}>{leader.name}</h3>
          <p className={styles.leaderTitle}>{leader.title}</p>
          <div className={styles.divider} />
          <div className={styles.quoteBlock}>
            <FaQuoteLeft className={styles.quoteIcon} />
            <p className={styles.quoteText}>{leader.quote}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Welcome() {
  const [headerRef, headerInView] = useInView(0.2);
  const [midRef, midInView] = useInView(0.1);

  return (
    <section className={styles.section}>
      <div className={styles.blob1} />
      <div className={styles.blob2} />
      <div className={styles.blob3} />
      <div className={styles.gridPattern} />

      <div className={styles.container}>

        {/* Section Header */}
        <div
          ref={headerRef}
          className={`${styles.sectionHeader} ${headerInView ? styles.headerVisible : ""}`}
        >
          <div className={styles.eyebrow}>
            <FaCross className={styles.eyebrowIcon} />
            <span>Our Ministry</span>
            <FaCross className={styles.eyebrowIcon} />
          </div>
          <h2 className={styles.sectionTitle}>
            Welcome to{" "}
            <span className={styles.titleHighlight}>
              Calvary Wide Fellowship Ministries
            </span>
          </h2>
          <div className={styles.titleUnderline} />
          <p className={styles.sectionSubtitle}>
            A Spirit-led community where faith is strengthened, lives are
            transformed, and the Kingdom of God is advanced.
          </p>
        </div>

        {/* 3-column equal-height grid */}
        <div className={styles.grid}>

          <LeaderCard leader={LEADERS[0]} delay={0} side="left" />

          {/* Cinematic centre panel */}
          <div
            ref={midRef}
            className={`${styles.midPanel} ${midInView ? styles.midVisible : ""}`}
          >
            <div className={styles.crossWatermark}>&#10011;</div>

            <div className={styles.midContent}>
              <span className={styles.midEyebrow}>Est. in Faith</span>

              <blockquote className={styles.midVerse}>
                "For Christ's love compels us, because we are convinced
                that one died for all, and therefore all died. And he died
                for all, that those who live should no longer live for
                themselves but for him who died for them and was raised again."
                <cite className={styles.midCite}>
                  — 2 Abakorinto / 2 Corinthians / 2 Corinthiens 5:14-15
                </cite>
              </blockquote>

              <div className={styles.midDivider} />

              <p className={styles.midText}>
                <strong>Calvary Wide Fellowship Ministries (CWFM)</strong> is
                committed to spreading the Gospel of Jesus Christ and
                transforming lives through the power of God's Word — built on
                worship, intercession, and discipleship.
              </p>
              <p className={styles.midText}>
                Every person is uniquely created by God with a divine purpose.
                Whether you seek spiritual growth, meaningful community, or a
                deeper walk with God, <em>you are welcome here.</em>
              </p>

              <a href="/fellowship" className={styles.midCta}>
                Begin Your Journey
                <span className={styles.ctaArrow}>&#8594;</span>
              </a>
            </div>
          </div>

          <LeaderCard leader={LEADERS[1]} delay={100} side="right" />
        </div>

      </div>
    </section>
  );
}
